// The one connection between www.imfuyo.farm and the Imfuyo Platform.
// Two things cross it: enquiries and registrations from website forms, and a customer checking their own Imfuyo account.
// The platform's address and sign-in are never shown on the site; this file only talks to its website door.
const BRIDGE = 'https://tofjyfseglykithjntfa.supabase.co/functions/v1/website-bridge';
// Site key: identifies the website to the platform. Set when the platform's website door is switched on.
const SITE_KEY = process.env.REACT_APP_IMFUYO_SITE_KEY || '';

async function call(action, body) {
  if (!SITE_KEY) throw new Error('The Imfuyo account service is not switched on yet.');
  const res = await fetch(`${BRIDGE}/${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Imfuyo-Site': SITE_KEY },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Imfuyo could not be reached. Please try again.');
  return data;
}

// Send a website enquiry or registration to the platform. Never throws: the website must keep working even if the platform is unreachable.
export async function sendToPlatform({ kind, name, phone, email, county, role, message, consent, source, extra }) {
  try {
    if (!SITE_KEY || !consent) return null;
    return await call('lead', {
      kind: kind || 'Contact', full_name: name || '', phone: phone || '', email: email || '', county: county || '', role: role || '',
      message: message || '', consent: !!consent, source_page: source || (typeof window !== 'undefined' ? window.location.pathname : ''), data: extra || {},
    });
  } catch (e) { return null; }
}

// A customer checks their own Imfuyo account with the account number (IMW-…) and the phone number registered with Imfuyo.
export function checkAccount(accountNo, phone) {
  return call('wallet', { account_no: accountNo, phone });
}

// The Academy exam asks the platform to reserve a certificate number after a pass. Never throws: the student's own certificate download must always work.
// The platform keeps the number as "awaiting confirmation" until Imfuyo confirms it; the public check page then shows it as valid.
export async function requestCertificate({ name, accessCode, phone, score, outOf }) {
  try {
    if (!SITE_KEY) return null;
    return await call('certificate', { name: name || '', access_code: accessCode || '', phone: phone || '', score, out_of: outOf });
  } catch (e) { return null; }
}
